import iso7064 from "iso-7064";
import { parseBankAccount } from "@/utils/bankAccountParser";
export default class UnresolvedPayment {
    _instructor;
    _value;
    _tax;
    constructor(instructor) {
        this._instructor = instructor;
        this.refresh();
    }
    refresh() {
        this._value = this._instructor.data.balance > 0
            ? this._instructor.data.balance
            : -this._instructor.data.balance;
        this._tax = this._instructor.data.paysTaxes
            ? Math.round(this.value * 0.15 * 100) / 100
            : 0;
    }
    get id() {
        return this._instructor.id;
    }
    get instructor() {
        return this._instructor;
    }
    get value() {
        return this._value;
    }
    set value(value) {
        this._value = value;
        this._tax = this._instructor.data.paysTaxes
            ? Math.round(this.value * 0.15 * 100) / 100
            : 0;
    }
    get tax() {
        return this._tax;
    }
    set tax(value) {
        this._tax = value;
    }
    get iban() {
        const parsed = parseBankAccount(this.instructor.data.bankAccount || '');
        if (!parsed) {
            return "";
        }
        const base = parsed.bankCode + parsed.prefix + parsed.account + 'CZ00';
        const confirmationCode = ("00" + (98 - iso7064.computeWithoutCheck(base))).substr(-2);
        return "CZ" + confirmationCode + parsed.bankCode + parsed.prefix + parsed.account;
    }
    get qr() {
        return [
            'SPD',
            '1.0',
            'ACC:' + this.iban,
            'AM:' + (this.value - this.tax),
            'CC: CZK',
        ].join('*');
    }
}
